import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row g-3 mb-25" }
const _hoisted_2 = { class: "col-xl-2 col-md-4 col-sm-6" }
const _hoisted_3 = { class: "summary-card" }
const _hoisted_4 = { class: "summary-label" }
const _hoisted_5 = { class: "summary-value text-success" }
const _hoisted_6 = { class: "col-xl-2 col-md-4 col-sm-6" }
const _hoisted_7 = { class: "summary-card" }
const _hoisted_8 = { class: "summary-label" }
const _hoisted_9 = { class: "summary-value text-danger" }
const _hoisted_10 = { class: "col-xl-2 col-md-4 col-sm-6" }
const _hoisted_11 = { class: "summary-card" }
const _hoisted_12 = { class: "summary-label" }
const _hoisted_13 = { class: "col-xl-2 col-md-4 col-sm-6" }
const _hoisted_14 = { class: "summary-card" }
const _hoisted_15 = { class: "summary-label" }
const _hoisted_16 = { class: "summary-value text-danger" }
const _hoisted_17 = { class: "col-xl-2 col-md-4 col-sm-6" }
const _hoisted_18 = { class: "summary-card" }
const _hoisted_19 = { class: "summary-label" }
const _hoisted_20 = { class: "summary-value text-danger" }
const _hoisted_21 = { class: "col-xl-2 col-md-4 col-sm-6" }
const _hoisted_22 = { class: "summary-card" }
const _hoisted_23 = { class: "summary-label" }
const _hoisted_24 = { class: "summary-value text-success" }
const _hoisted_25 = { class: "col-xl-2 col-md-8 col-sm-12" }
const _hoisted_26 = { class: "summary-card profit-card" }
const _hoisted_27 = { class: "summary-label" }
const _hoisted_28 = {
  key: 0,
  class: "income-note mb-25"
}
const _hoisted_29 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_30 = { class: "card-body p-xl-40" }
const _hoisted_31 = { class: "py-4 text-center text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_sales`)), 1),
          _createElementVNode("strong", _hoisted_5, "$" + _toDisplayString(_ctx.formatNumber(_ctx.summary.sales)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_sales_return`)), 1),
          _createElementVNode("strong", _hoisted_9, "$" + _toDisplayString(_ctx.formatNumber(_ctx.summary.sales_returns)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_income`)), 1),
          _createElementVNode("strong", {
            class: _normalizeClass(["summary-value", _ctx.includesIncome ? 'text-primary' : 'text-muted'])
          }, " $" + _toDisplayString(_ctx.formatNumber(_ctx.summary.income)), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_purchases`)), 1),
          _createElementVNode("strong", _hoisted_16, "$" + _toDisplayString(_ctx.formatNumber(_ctx.summary.purchases)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_expenses`)), 1),
          _createElementVNode("strong", _hoisted_20, "$" + _toDisplayString(_ctx.formatNumber(_ctx.summary.expenses)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_net_sales`)), 1),
          _createElementVNode("strong", _hoisted_24, "$" + _toDisplayString(_ctx.formatNumber(_ctx.summary.sales - _ctx.summary.sales_returns)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.summary_net_profit`)), 1),
          _createElementVNode("strong", {
            class: _normalizeClass(["summary-value", _ctx.summary.net_profit >= 0 ? 'text-success' : 'text-danger'])
          }, " $" + _toDisplayString(_ctx.formatNumber(_ctx.summary.net_profit)), 3)
        ])
      ])
    ]),
    (!_ctx.includesIncome)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.income_note`)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_a_table, {
          columns: _ctx.columns,
          "data-source": _ctx.rows,
          "row-key": 'month',
          loading: _ctx.loading,
          pagination: false,
          scroll: { x: 980 },
          class: "text-nowrap align-middle profit-loss-table"
        }, {
          emptyText: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.no_profit_loss_data_found`)), 1)
          ]),
          bodyCell: _withCtx(({ column, record }) => [
            (column && column.key === 'month')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatMonth(record.month)), 1)
                ], 64))
              : (column && _ctx.monetaryColumns.includes(String(column.key)))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(_ctx.getMoneyClass(String(column.key), record))
                  }, " $" + _toDisplayString(_ctx.formatNumber(Number(record[String(column.key) as keyof typeof record] || 0))), 3))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "loading"])
      ])
    ])
  ], 64))
}